import React from 'react'
import { number } from 'prop-types'

export const Price = ({ value }) => (
  <span>
    { value ? value.toFixed(2) : 0.00 } €
  </span>
)

Price.propTypes = {
  value: number
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/Price.js